if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const cartElement =
        this.cart ||
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

        if (cartElement) {
          this.cart = cartElement;
          
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.headers['Content-Type'] = 'application/json';


        const variantId = formData.get('id');
        const quantity = parseInt(formData.get('quantity')) || 1;
        const sellingPlan = formData.get('selling_plan');

        const pfandDosen = parseInt(this.dataset.pfandDosen) || 0;

        const pfandVariantIds = {
            4: '54315701010770',
           12: '54317633503570',
           24: '54317633241426',
         };

         const pfandVariantId = pfandVariantIds[pfandDosen];


        const items = [
          {
          id: Number(variantId),
          quantity: quantity,
        },
       ];

        if (pfandDosen > 0 && pfandVariantId) {
          const pfandItem = {
            id: Number(pfandVariantId),
            quantity: quantity,
            properties: {
             '_pfand_for_variant': String(variantId),
             '_pfand_quantity_per_bundle': String(pfandDosen),
            },
         };

         if (sellingPlan) {
           pfandItem.selling_plan = Number(sellingPlan);
         }

         items.push(pfandItem);
       }

        const cartPayload = {
          items: items,
        };

        const sections = this.cart
        ? this.cart.getSectionsToRender().map((section) => section.id)
        : [];

        if (sections.length > 0) {
          cartPayload.sections = sections;
          cartPayload.sections_url = window.location.pathname;
        }

        config.body = JSON.stringify(cartPayload);


        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            fetch(window.Shopify.routes.root + 'cart.js')
             .then((cartResponse) => cartResponse.json())
             .then((cartData) => {
              const bundleLine = cartData.items.find(
                (item) => String(item.variant_id) === String(variantId)
              );

               if (!bundleLine?.selling_plan_allocation) return;

               const sellingPlanId =
                bundleLine.selling_plan_allocation.selling_plan.id;

              const pfandLine = cartData.items.find(
                (item) =>
                  item.properties?._pfand_for_variant === String(variantId)
              );

              if (!pfandLine || pfandLine.selling_plan_allocation) return;

              return fetch(window.Shopify.routes.root + 'cart/change.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: pfandLine.key,
                  quantity: pfandLine.quantity,
                  selling_plan: sellingPlanId,
               }),
             });
          })
          .catch((error) => {
            console.error('Pfand selling plan sync failed:', error);
          });
    
            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);

                // 24er Sparabo: normalen Pfand nach abgeschlossenem Cart-Render
// gegen den speziellen Abo-Pfand austauschen.
if (pfandDosen === 24) {
  const xhrRequest = (method, url, data = null) =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.open(method, url, true);

      if (data) {
        xhr.setRequestHeader('Content-Type', 'application/json');
      }

      xhr.onload = function () {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            resolve(JSON.parse(xhr.responseText));
          } catch {
            resolve(xhr.responseText);
          }
        } else {
          reject(new Error(`Pfand XHR Fehler: ${xhr.status}`));
        }
      };

      xhr.onerror = function () {
        reject(new Error('Pfand XHR Netzwerkfehler'));
      };

      xhr.send(data ? JSON.stringify(data) : null);
    });

  xhrRequest('GET', window.Shopify.routes.root + 'cart.js')
    .then(async (cartData) => {
      const bundleLine = cartData.items.find(
        (item) => String(item.variant_id) === String(variantId)
      );

      // Kein Sparabo -> nichts ändern.
      if (!bundleLine?.selling_plan_allocation) return;

      const sellingPlanId =
        bundleLine.selling_plan_allocation.selling_plan.id;

      const normalPfandLine = cartData.items.find(
        (item) =>
          String(item.variant_id) === '54317633241426' &&
          item.properties?._pfand_for_variant === String(variantId)
      );

      const aboPfandLine = cartData.items.find(
        (item) =>
          String(item.variant_id) === '54509339476306' &&
          item.properties?._pfand_for_variant === String(variantId)
      );

      // Falls der Abo-Pfand noch nicht vorhanden ist:
      // zuerst hinzufügen.
      if (!aboPfandLine) {
        await xhrRequest(
          'POST',
          window.Shopify.routes.root + 'cart/add.js',
          {
            items: [
              {
                id: 54509339476306,
                quantity: normalPfandLine?.quantity || quantity,
                selling_plan: sellingPlanId,
                properties: {
                  '_pfand_for_variant': String(variantId),
                  '_pfand_quantity_per_bundle': '24',
                },
              },
            ],
          }
        );
      }

     // Nach dem Hinzufügen den Warenkorb noch einmal frisch laden.
// Der Key des normalen Pfands kann sich durch den Selling Plan geändert haben.
const refreshedCart = await xhrRequest(
  'GET',
  window.Shopify.routes.root + 'cart.js'
);

const refreshedNormalPfandLine = refreshedCart.items.find(
  (item) =>
    String(item.variant_id) === '54317633241426' &&
    item.properties?._pfand_for_variant === String(variantId)
);

// Jetzt den aktuell gültigen Pfand-Key verwenden.
if (refreshedNormalPfandLine) {
  await xhrRequest(
    'POST',
    window.Shopify.routes.root + 'cart/change.js',
    {
      id: refreshedNormalPfandLine.key,
      quantity: 0,
    }
  );
}
// Nach abgeschlossenem Pfand-Swap nur den Footer
// mit dem aktuellen serverseitigen Warenkorb neu laden.
const drawerResponse = await xhrRequest(
  'GET',
  window.Shopify.routes.root + 'cart?section_id=cart-drawer'
);

const drawerDocument = new DOMParser().parseFromString(
  drawerResponse,
  'text/html'
);

const freshFooter = drawerDocument.querySelector(
  '.cart-drawer__footer'
);

const currentFooter = document.querySelector(
  '.cart-drawer__footer'
);

if (freshFooter && currentFooter) {
  currentFooter.innerHTML = freshFooter.innerHTML;
}
    })
    .catch((error) => {
      console.error('Pfand Abo XHR swap failed:', error);
    });
}
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
